export const sortMediaPosition = (a, b) => {
  const assignPos = pos => {
    if (pos === 0) return Infinity;
    return pos;
  };
  return assignPos(a.position) - assignPos(b.position);
};
